import React from 'react';
import { Route, Switch } from 'react-router';
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';
import useLanguage from '../utils/hooks/useLanguage';
import useTheme from '../utils/hooks/useTheme';
import useQuery from '../utils/hooks/useQuery';
import { Theme } from '../styles/theme/Theme';
import Caurosel from '../components/Carousel';
import NotFound from '../components/NotFound';
// import CredentialContext from '../config/CredentialContext';

const Routes = () => {
  const { locale, translations } = useLanguage();
  const query = useQuery();
  const theme = useTheme(query.get('theme'));

  return (
    <ThemeProvider theme={theme}>
      <Theme />
      <IntlProvider locale={locale} messages={translations}>
        {/* <CredentialContext.Provider value={{ language: query.get('language') }}> */}
        <Switch>
          <Route
            path="/:platform/:version/:userStatus"
            component={Caurosel}
            exact
          />
          <Route component={NotFound} />
        </Switch>
        {/* </CredentialContext.Provider> */}
      </IntlProvider>
    </ThemeProvider>
  );
};

export default Routes;
